const __WEBPACK_NAMESPACE_OBJECT__ = require("@metamask/obs-store");